<div class="company-form-checkbox">
	<mat-checkbox class="d-block" #refToogleAll [(ngModel)]="toogleAllModel" (change)="toogleAll(refToogleAll)"
		>Todas</mat-checkbox
	>
	<div *ngFor="let company of companiesOptions">
		<div class="d-flex">
			<mat-checkbox
				#refMasterCompany
				class="d-block"
				[(ngModel)]="company.checked"
				[indeterminate]="company.indeterminate"
				[ngModelOptions]="{ standalone: true }"
				(change)="onChangeMasterCompanyState(company, refMasterCompany)"
				>{{ company.label }}</mat-checkbox
			>
			<button
				type="button"
				mat-icon-button
				[attr.aria-label]="'toggle ' + company.label"
				(click)="company.active = !company.active"
			>
				<mat-icon class="mat-icon-rtl-mirror">
					{{ company.active ? 'expand_more' : 'chevron_right' }}
				</mat-icon>
			</button>
		</div>
		<ul *ngIf="company.active && company.children && company.children.length > 0">
			<li *ngFor="let children of company.children">
				<div class="d-flex">
					<mat-checkbox
						#refCheckboxCompany
						class="d-block"
						[(ngModel)]="children.checked"
						[ngModelOptions]="{ standalone: true }"
						[indeterminate]="children.indeterminate"
						(change)="onChangeChildrenCompanyState(children, refCheckboxCompany, company, refMasterCompany)"
						>{{ children.label }}</mat-checkbox
					>
					<button
						type="button"
						mat-icon-button
						[attr.aria-label]="'toggle ' + children.label"
						(click)="children.active = !children.active"
					>
						<mat-icon class="mat-icon-rtl-mirror">
							{{ children.active ? 'expand_more' : 'chevron_right' }}
						</mat-icon>
					</button>
				</div>
				<ul *ngIf="children.active">
					<li>
						<mat-checkbox
							class="d-block"
							[(ngModel)]="children.availableForEmployees"
							[ngModelOptions]="{ standalone: true }"
							(change)="onChangeStateCheckElements(children, refCheckboxCompany, company, refMasterCompany)"
							>Disponível para colaboradores</mat-checkbox
						>
					</li>
					<li>
						<mat-checkbox
							class="d-block"
							[(ngModel)]="children.availableForDependents"
							[ngModelOptions]="{ standalone: true }"
							(change)="onChangeStateCheckElements(children, refCheckboxCompany, company, refMasterCompany)"
							>Dependentes maiores de 18 anos</mat-checkbox
						>
					</li>
					<li>
						<mat-checkbox
							class="d-block"
							*ngIf="children.availableForDependents"
							[(ngModel)]="children.availableForMinors"
							[ngModelOptions]="{ standalone: true }"
							(change)="onChangeStateCheckElements(children, refCheckboxCompany, company, refMasterCompany)"
							>Dependentes menores de 18 anos</mat-checkbox
						>
					</li>
				</ul>
			</li>
		</ul>
		<ul *ngIf="company.active && (!company.children || company.children.length == 0)">
			<li>
				<mat-checkbox
					class="d-block"
					[(ngModel)]="company.availableForEmployees"
					[ngModelOptions]="{ standalone: true }"
					(change)="onChangeStateCheckElements(company, refMasterCompany)"
					>Disponível para colaboradores</mat-checkbox
				>
			</li>
			<li>
				<mat-checkbox
					class="d-block"
					[(ngModel)]="company.availableForDependents"
					[ngModelOptions]="{ standalone: true }"
					(change)="onChangeStateCheckElements(company, refMasterCompany)"
					>Dependentes maiores de 18 anos</mat-checkbox
				>
			</li>
			<li>
				<mat-checkbox
					*ngIf="company.availableForDependents"
					class="d-block"
					[(ngModel)]="company.availableForMinors"
					[ngModelOptions]="{ standalone: true }"
					(change)="onChangeStateCheckElements(company, refMasterCompany)"
					>Dependentes menores de 18 anos</mat-checkbox
				>
			</li>
		</ul>
	</div>
</div>
